/**
 * Dawn overlays an invisible full-card link on top of every product card so
 * the whole card is clickable through to the PDP (`.card__heading a::after`,
 * position:absolute, inset:0). For the "standard" + "media" card combo this
 * theme uses, that link's real host `.card__content` is a SIBLING of
 * `.card__inner` (not nested inside it) — `.card__inner` holds the image and
 * a second, hidden `.card__content`, while the visible title/price block
 * with the actual working link sits right after `.card__inner` closes, both
 * as children of `.card`.
 *
 * That link keeps winning the browser's hit-test over our quick-add button
 * regardless of the button's own z-index, because the button lives inside
 * `.card__inner`, which creates its own stacking context (via the
 * `transform: perspective(0)` rule that ships with Dawn's `.gradient`
 * class). A z-index set inside that bubble only ranks within the bubble —
 * it can't reach out and outrank a sibling positioned element sitting
 * outside it, no matter how high the number.
 *
 * Rather than keep fighting stacking context, this intercepts clicks in the
 * capture phase, before Dawn's link navigates anywhere: if the pointer was
 * actually over our overlay's box when the click landed on something else,
 * we cancel that click and replay it on our own button instead. The search
 * for a shared ancestor uses `.card` (not `.card__inner`), since that's the
 * lowest common ancestor of both the invisible link and our overlay.
 */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var card = event.target.closest('.card');
      if (!card) return;

      var overlay = card.querySelector('.quick-add-to-cart-overlay');
      if (!overlay || overlay.contains(event.target)) return;

      var rect = overlay.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      ) {
        return;
      }

      var button = overlay.querySelector('button');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      button.click();
    },
    true
  );
})();
